import structure from './courseStructure.json';

/**
 * Maria, 28 October 2026: there is one training course, the one in public/training-course, shown in the Help Centre
 * on the Training course tab. Its lessons, videos and knowledge check answers are read from courseStructure.json,
 * which is built from the course itself (npm run help:course). Nothing here holds any of the course's text.
 */
export const COURSE_AUDIENCES = ['school-admin', 'senior-staff', 'staff'];

export const lessons = structure.lessons;

export const allTopics = lessons.flatMap(lesson =>
    lesson.topics.map(topic => ({...topic, lessonId: lesson.id})));

export const findTopic = topicId => allTopics.find(topic => topic.id === topicId);

export const findLesson = lessonId => lessons.find(lesson => lesson.id === lessonId);

export const lessonForChapter = chapter => lessons.find(lesson => lesson.chapter === Number(chapter));

export const courseFor = audience => (COURSE_AUDIENCES.includes(audience) ? lessons : []);
